import { ReactNode } from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { TIconSize } from "@/components/ui/atoms"

const baseButtonVariants = cva("baseButton", {
  variants: {
    variant: {
      primary: "baseButton--primary",
      secondary: "baseButton--secondary",
      ghost: "baseButton--ghost",
    },
    reverse: {
      true: "baseButton--reverse",
    },
  },
  defaultVariants: {
    variant: "primary",
    reverse: false,
  },
})

interface IBaseButtonVariantProps
  extends VariantProps<typeof baseButtonVariants> {
  children?: ReactNode
  iconLeft?: string
  iconRight?: string
  iconSize?: TIconSize
}

export { baseButtonVariants, type IBaseButtonVariantProps }
